var _path, _circle, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 248,
    viewBox: "0 0 730 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M730 18C730 8.05888 721.941 0 712 0H464C454.059 0 446 8.05887 446 18V57.8039C446 68.8496 454.954 77.8039 466 77.8039H477.395C494.85 77.8039 509 91.9539 509 109.409C509 119.676 517.324 128 527.591 128H712C721.941 128 730 119.941 730 110V18Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 108,
    r: 25,
    fill: "#151521"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.855 108C491.855 111.94 490.29 115.719 487.503 118.506C484.717 121.292 480.938 122.857 476.998 122.857C473.057 122.857 469.278 121.292 466.492 118.506C463.706 115.719 462.141 111.94 462.141 108M491.855 108C491.855 104.06 490.29 100.281 487.503 97.4944C484.717 94.7081 480.938 93.1428 476.998 93.1428C473.057 93.1428 469.278 94.7081 466.492 97.4944C463.706 100.281 462.141 104.06 462.141 108M491.855 108H462.141",
    stroke: "#2DCA8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.71 108C482.429 113.433 480.428 118.636 476.996 122.857C473.563 118.636 471.562 113.433 471.281 108C471.562 102.567 473.563 97.3637 476.996 93.1428C480.428 97.3637 482.429 102.567 482.71 108Z",
    stroke: "#2DCA8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M444.56 97C444.56 86.5066 436.053 78 425.56 78H20C9.50659 78 1 86.5066 1 97V228C1 238.493 9.50659 247 20 247H486C496.493 247 505 238.493 505 228V160C505 149.507 496.493 141 486 141H479.56C460.23 141 444.56 125.33 444.56 106V97Z",
    stroke: "#2DCA8F",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(461 92)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.257c86d1f2bc14d6622a520f72b5c3d4.svg";
export { ForwardRef as ReactComponent };